<template>
  <div
    :class="customerClass ? customerClass + ' dates' : 'dates'"
    :style="!$vuetify.breakpoint.smAndDown ? '' : 'margin-top:15px;'"
  >
    <div class="date-select">
      <div
        :class="
          selected === 1 ? 'active date-item primary white--text' : 'date-item'
        "
        @click="dayClick()"
      >
        Dag
      </div>
      <div
        :class="
          selected === 2 ? 'active date-item primary white--text' : 'date-item'
        "
        @click="monthClick()"
      >
        Måned
      </div>
      <div
        :class="
          selected === 3 ? 'active date-item primary white--text' : 'date-item'
        "
        @click="yearClick()"
      >
        År
      </div>
    </div>

    <div
      class="date-picker"
      :style="!$vuetify.breakpoint.smAndDown ? '' : 'margin-top:15px;'"
    >
      <div class="prev" @click="reduceDate()">
        <v-icon color="primary">fa-chevron-left</v-icon>
      </div>
      <div class="label">{{ getStructuredDate() }}</div>
      <div class="next" @click="increaseDate()">
        <v-icon color="primary">fa-chevron-right</v-icon>
      </div>
    </div>
  </div>
</template>

<script>
import "./DatePicker.scss";
import { getNorwayMonth } from "../../utils/date";

export default {
  name: "DatePicker",

  props: ["getSelectedDate", "start"],

  data() {
    return {
      customerClass: "",
      selected: 2,
      selectedDay: "",
      selectedMonth: "",
      selectedYear: "",
      date: "",
      days: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
      ],
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      years: [
        "2018",
        "2019",
        "2020",
        "2021",
        "2022",
        "2023",
        "2024",
        "2025",
        "2026",
        "2027",
        "2028",
        "2029",
        "2030",
      ],
      requestedMonth: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
      ],
      selectedData: {},
      selectedDate: "",
    };
  },

  beforeMount() {
    this.setMonth();
  },

  mounted() {},

  watch: {
    selectedData(data) {
      this.$emit("getSelectedDate", data, this.selectedDate);
    },
  },

  methods: {
    dayClick() {
      this.selected = 1;
      this.setDay();
    },

    monthClick() {
      this.selected = 2;
      this.setMonth();
    },

    yearClick() {
      this.selected = 3;
      this.setYear();
    },

    setDay() {
      if (!this.selectedDay && this.selectedDay !== 0) {
        let day = this.$moment().subtract(1, "days").format("DD");
        this.selectedDay = this.days.findIndex((item) => {
          return item === day;
        });
      }

      this.setMonth();
      this.setYear();
    },

    setMonth() {
      if (!this.selectedMonth && this.selectedMonth !== 0) {
        let month = this.$moment().format("MMMM");
        this.selectedMonth = this.months.findIndex((item) => {
          return item === month;
        });
      }

      this.setYear();
    },

    setYear() {
      if (!this.selectedYear && this.selectedYear !== 0) {
        let year = this.$moment().format("YYYY");
        this.selectedYear = this.years.findIndex((item) => {
          return item === year;
        });
      }
    },

    reduceDate() {
      let tmp = "";

      if (
        (this.selectedYear || this.selectedYear === 0) &&
        this.years[this.selectedYear]
      ) {
        tmp += this.years[this.selectedYear];
      }

      if (
        (this.selectedMonth || this.selectedMonth === 0) &&
        this.months[this.selectedMonth]
      ) {
        let currentMonth = this.selectedMonth + 1;
        currentMonth = currentMonth < 10 ? "0" + currentMonth : currentMonth;
        tmp += "-" + currentMonth;
      }

      if (
        (this.selectedDay || this.selectedDay === 0) &&
        this.days[this.selectedDay]
      ) {
        tmp += "-" + this.days[this.selectedDay];
      }

      console.log(tmp.trim());

      tmp = this.$moment(tmp.trim());

      switch (this.selected) {
        case 1:
          tmp.add(-1, "days");

          break;

        case 2:
          tmp.add(-1, "months");

          break;

        case 3:
          tmp.add(-1, "years");
          break;
      }

      console.log(tmp);

      this.selectedDay = this.days.findIndex((item) => {
        return item === tmp.format("DD");
      });

      this.selectedMonth = this.months.findIndex((item) => {
        return item === tmp.format("MMMM");
      });

      this.selectedYear = this.years.findIndex((item) => {
        return item === tmp.format("YYYY");
      });
    },

    increaseDate() {
      let tmp = "";

      if (
        (this.selectedYear || this.selectedYear === 0) &&
        this.years[this.selectedYear]
      ) {
        tmp += this.years[this.selectedYear];
      }

      if (
        (this.selectedMonth || this.selectedMonth === 0) &&
        this.months[this.selectedMonth]
      ) {
        let currentMonth = this.selectedMonth + 1;
        currentMonth = currentMonth < 10 ? "0" + currentMonth : currentMonth;
        tmp += "-" + currentMonth;
      }

      if (
        (this.selectedDay || this.selectedDay === 0) &&
        this.days[this.selectedDay]
      ) {
        tmp += "-" + this.days[this.selectedDay];
      }

      tmp = this.$moment(tmp.trim());

      switch (this.selected) {
        case 1:
          tmp.add(1, "days");

          break;

        case 2:
          tmp.add(1, "months");

          break;

        case 3:
          tmp.add(1, "years");

          break;
      }

      console.log(tmp);

      this.selectedDay = this.days.findIndex((item) => {
        return item === tmp.format("DD");
      });

      this.selectedMonth = this.months.findIndex((item) => {
        return item === tmp.format("MMMM");
      });

      this.selectedYear = this.years.findIndex((item) => {
        return item === tmp.format("YYYY");
      });
    },

    getStructuredDate() {
      let date = "",
        requestedDate = "",
        agg = "",
        formatedDate = "",
        day = this.selectedDay,
        month = this.selectedMonth,
        year = this.selectedYear;

      switch (this.selected) {
        case 1:
          agg = "h";
          date =
            this.days[day] + " " + this.months[month] + " " + this.years[year];
          requestedDate =
            this.years[year] + this.requestedMonth[month] + this.days[day];
          formatedDate =
            this.days[day] +
            " " +
            getNorwayMonth(month) +
            " " +
            this.years[year];
          break;

        case 2:
          agg = "d";
          date = this.months[month] + " " + this.years[year];
          requestedDate = this.years[year] + this.requestedMonth[month];
          formatedDate = getNorwayMonth(month) + " " + this.years[year];
          break;

        case 3:
          agg = "m";
          date = this.years[year];
          requestedDate = this.years[year];
          formatedDate = this.years[year];
          break;
      }

      this.selectedData = { requestedDate, date, agg };
      this.selectedDate = formatedDate;

      return formatedDate;
    },
  },
};
</script>